import { useCommonReconApiMutation } from "./apiSlices/reconApi";

const useApiHouse = () => {
    const [apiFunction, response] = useCommonReconApiMutation();
    return [apiFunction, response];
}
 
export default useApiHouse;